export const transferEngineTrueFalseMapping = {
  true: "Yes",
  false: "No",
};
